import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Footer } from '@/components/Ui/Footer';
import { ImpersonationBanner } from '@/components/Ui/ImpersonationBanner';
import { MobileNav } from '@/components/Ui/MobileNav';
import { PageHeader } from '@/components/Ui/PageHeader';
import ScrollToTop from '@/components/Ui/ScrollToTop';
import { QuoteProvider } from '@/contexts/QuoteContext';
import DialogRoutes, { type DialogRouteState } from '@/DialogRoutes';
import auth from '@/helpers/auth';
import Background from '@/images/background.jpg';
import BrandedPage from '@/pages/BrandedPage';
import Routes from '@/Routes';

function App() {
    const location = useLocation();
    const state = location.state as DialogRouteState | null;
    const [
        refreshKey,
        setRefreshKey,
    ] = useState(0);

    useEffect(() => {
        const handleSessionChanged = () => {
            setRefreshKey((prev) => {
                return prev + 1;
            });
        };

        window.addEventListener('session-changed', handleSessionChanged);

        return () => {
            window.removeEventListener('session-changed', handleSessionChanged);
        };
    }, []);

    const isCatalog = location.pathname === '/catalog';
    const isOrderHistory = location.pathname === '/quotes';

    const hasColoredBackground = ~[
        '/about',
        '/contact',
        '/profile',
    ].indexOf(location.pathname);

    // Unset state when refreshing the page.
    // window.history.replaceState({}, '');

    if (auth.isAnonymous() || auth.isRefreshRequired() || auth.is2faDisabled()) {
        return (
            <BrandedPage>
                <Routes />
            </BrandedPage>
        );
    }
    return (
        <QuoteProvider>
            <ImpersonationBanner />

            {/* Static sidebar for desktop */}
            <PageHeader
                onSettingsChange={ () => {
                    return setRefreshKey(refreshKey + 1);
                } }
            />

            <div className={
                clsx(
                    'relative mx-auto flex w-full max-w-8xl flex-auto justify-center sm:px-2 lg:px-4 bg-background text-foreground',
                    hasColoredBackground ? 'bg-cover bg-center bg-no-repeat' : false)
            }
            style={ hasColoredBackground ? { backgroundImage: `url(${ Background })` } : {} }>
                <div className='min-w-0 flex-auto px-0 md:px-4 pb-8'>
                    <main className='px-4 mt-4 lg:mt-8 mb-16 min-h-screen'>
                        <ScrollToTop />
                        <Routes key={ refreshKey } />
                        {!!state?.dialogAction && <DialogRoutes state={ state }/>}
                    </main>
                </div>
            </div>

            <Footer />

            {!isCatalog && !isOrderHistory && <MobileNav />}
        </QuoteProvider>
    );
}

export default App;
